import ReactDOM from "react-dom/client";
import App from "@src/App.tsx";
import "@src/index.scss";
import "@src/videojs.css";
import ErrorBoundary from "@components/ErrorBoundary/ErrorBoundary.tsx";
import { ActionCableProvider } from "react-actioncable-provider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const socketUrl = import.meta.env.VITE_SOCKET_URL + "/cable";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <GoogleReCaptchaProvider
      reCaptchaKey={import.meta.env.VITE_CAPTCHA_KEY}
      scriptProps={{
        async: false, // optional, default to false,
        defer: false, // optional, default to false
        appendTo: "head", // optional, default to "head", can be "head" or "body",
        nonce: undefined, // optional, default undefined
      }}
      container={{
        // optional to render inside custom element
        element: "[required_id_or_htmlelement]",
        parameters: {
          theme: "dark",
        },
      }}
    >
      <QueryClientProvider client={queryClient}>
        <ActionCableProvider url={socketUrl}>
          <App />
        </ActionCableProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </GoogleReCaptchaProvider>
  </ErrorBoundary>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/", type: "module" })
      .then((registration) => {
        // Force-check for updates after successful registration
        registration.update();
        navigator.serviceWorker.addEventListener("message", (event) => {
          if (event.data?.type === "CACHE_UPDATED") {
            //re-load the page on new service worker registration
            window.location.reload();
          }
        });
      })
      .catch(() => {});
  });
}
